import i18n from 'helper/i18n';
import { filterForTag } from './utils';

import { ContentTypePoolRecipeDtoType } from 'types/services/magnolia/dtos/ContentTypePoolRecipeDto';

export const FILTER_ID = 'RECIPE_MENU_TYPE' as const;

export function getFilterByFilterTagId(filterTagId?: string) {
	if (!filterTagId) {
		return;
	}
	let filter: keyof typeof FILTER | undefined;
	Object.keys(MENU_TYPES).every((key) => {
		if (MENU_TYPES[key] === filterTagId) {
			filter = FILTER[key];
			return false;
		}
		return true;
	});
	if (filter) {
		return filter;
	}
	Object.keys(DISH_TYPES).every((key) => {
		if (DISH_TYPES[key] === filterTagId) {
			filter = FILTER[key];
			return false;
		}
		return true;
	});
	return filter;
}

export const FILTER = {
	APERO: 'APERO',
	BRUNCH: 'BRUNCH',
	DESSERT: 'DESSERT',
	BEVERAGE: 'BEVERAGE',
	MAIN: 'MAIN',
	SALAD: 'SALAD',
	SOUP: 'SOUP',
} as const;

export const MENU_TYPES = {
	APERO: '248',
	BRUNCH: '258',
	DESSERT: '10',
	BEVERAGE: '12',
	MAIN: '9',
} as const;

export const DISH_TYPES = {
	SALAD: '249',
	SOUP: '222',
} as const;

export const TAG_ID = {
	MENU_TYPE: 'menu-type',
	DISH_TYPE: 'dish-types',
} as const;

export const FILTER_FACTORY = {
	APERO: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID.MENU_TYPE, MENU_TYPES.APERO),
	BRUNCH: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID.MENU_TYPE, MENU_TYPES.BRUNCH),
	BEVERAGE: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID.MENU_TYPE, MENU_TYPES.BEVERAGE),
	MAIN: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID.MENU_TYPE, MENU_TYPES.MAIN),
	DESSERT: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID.MENU_TYPE, MENU_TYPES.DESSERT),
	SALAD: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID.DISH_TYPE, DISH_TYPES.SALAD),
	SOUP: (item: ContentTypePoolRecipeDtoType) => filterForTag(item, TAG_ID.DISH_TYPE, DISH_TYPES.SOUP),
};

export const FILTER_LABELS = {
	APERO: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.APERO}`),
	BRUNCH: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.BRUNCH}`),
	BEVERAGE: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.BEVERAGE}`),
	MAIN: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.MAIN}`),
	DESSERT: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.DESSERT}`),
	SALAD: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.SALAD}`),
	SOUP: i18n(`react.impulsCoach.components.tagFilter.recipe.${FILTER_ID}.${FILTER.SOUP}`),
};

export function filterForMenuType(filter: (keyof typeof FILTER)[]): (item: ContentTypePoolRecipeDtoType) => boolean {
	return (item: ContentTypePoolRecipeDtoType) => {
		return filter.some((currentFilter) => {
			return FILTER_FACTORY[currentFilter](item);
		});
	};
}

export default filterForMenuType;
